import { combineReducers } from "redux";
import { layoutMode } from "./layoutMode";
import { selectedTabId } from "./selectedTabId";
import { tabs } from "./tabs";
import { tabsById } from "./tabsById";

export const layout = combineReducers({
  layoutMode,
  tabs,
  tabsById,
  selectedTabId,
});
